<template>
  <div>
    <span v-if="styledText && styledText.noBoldText">
      {{ styledText.noBoldText }}
      <strong v-if="styledText.boldText"> {{ styledText.boldText }} </strong>
      {{ styledText.prepositionText ?
        styledText.prepositionText : '' }}
      <strong v-if="styledText.composedBoldText"> {{ styledText.composedBoldText }} </strong>
    </span>
  </div>
</template>
<script>

export default {
  name: 'CustomSelectIconListItemText',

  components: {
  },

  props: {
    styledText: {
      type: Object,
      default: undefined,
      required: false,
    },
  },
};
</script>
<style module>
</style>
